// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--20WK3";
export var inner = "footer-module--inner--17EUW";